import { createContext } from "react";

interface ToastContextInterface {
  open: (type: "info" | "success" | "error", message: string) => void;
}

export const ToastContext = createContext<ToastContextInterface>({
  open: () => {},
});
